// import { saveAs } from 'file-saver';

/**
 * 生成指定区间的随机整数
 * @param min{number}
 * @param max{number}
 * @returns {number}
 */
export function randomNum(max, min) {
  return Math.floor(Math.random() * (max - min) + min);
}

/**
 * 支持url blob File 下载
 * */
// export function download(fileUrl, filename) {
//   let name = '';
//   if (!filename) {
//     name = filename + fileUrl.match(this.reg)[0];
//   } else {
//     name = filename;
//   }
//   saveAs(fileUrl, name);
// }

/**
 * list to tree
 * */
export function listToTree(data) {
  let arr = JSON.parse(JSON.stringify(data));
  const listChildren = (obj, filter) => {
    [arr, obj.children] = arr.reduce(
      (res, val) => {
        if (filter(val)) res[1].push(val);
        else res[0].push(val);
        return res;
      },
      [[], []],
    );
    obj.children.forEach(val => {
      if (arr.length) listChildren(val, obj => obj.parentId === val.id);
    });
  };

  const tree = {};
  listChildren(tree, val => arr.findIndex(i => i.id === val.parentId) === -1);
  return tree.children;
}

/**
 * 拍平数组
 * flattenArray
 * instruction:
 * let obj = flattenArray(arr);
 * console.log(obj)
 */
export function flattenArray(arr, childKey = 'sonMenuList') {
  let flattenArr = [];
  arr.forEach(item => {
    flattenArr.push(item);
    if (item[childKey] && item[childKey].length > 0) {
      flattenArr = flattenArr.concat(flattenArray(item[childKey], childKey));
    }
  });
  return flattenArr;
}

export function filterButton(btns) {
  let obj = {};
  let arr = [];
  Object.keys(btns).forEach(key => {
    obj[key] = btns[key].label;
    arr.push({ name: btns[key].value, value: btns[key].label });
  });
  return {
    btnType: obj,
    list: arr,
  };
}

export const timeUtils = {
  //转化时间格式：年-月-日
  formateDate: function (time) {
    var date = new Date(time);
    var year = date.getFullYear();
    var month = ('0' + (date.getMonth() + 1)).substr(-2, 2);
    var day = ('0' + date.getDate()).substr(-2, 2);
    return year + '-' + month + '-' + day;
  },
  //转化时间格式：年-月-日
  getCurrentDate: function () {
    var date = new Date();
    var year = date.getFullYear();
    var month = ('0' + (date.getMonth() + 1)).substr(-2, 2);
    var day = ('0' + date.getDate()).substr(-2, 2);
    return year + '-' + month + '-' + day;
  },
  //转化时间格式：年-月-日 时：分：秒
  formateTime: function (time) {
    var date = new Date(time);
    var year = date.getFullYear();
    var month = ('0' + (date.getMonth() + 1)).substr(-2, 2);
    var day = ('0' + date.getDate()).substr(-2, 2);
    var hour = ('0' + date.getHours()).substr(-2, 2);
    var minute = ('0' + date.getMinutes()).substr(-2, 2);
    var sconde = ('0' + date.getSeconds()).substr(-2, 2);
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + sconde;
  },
  //转化时间格式：时：分：秒
  formateHours: function (time) {
    var date = new Date(time);
    var hour = ('0' + date.getHours()).substr(-2, 2);
    var minute = ('0' + date.getMinutes()).substr(-2, 2);
    var sconde = ('0' + date.getSeconds()).substr(-2, 2);
    return hour + ':' + minute + ':' + sconde;
  },
  //转化时间格式：时：分
  formateHours2: function (time) {
    var date = new Date(time);
    var hour = ('0' + date.getHours()).substr(-2, 2);
    var minute = ('0' + date.getMinutes()).substr(-2, 2);
    var sconde = ('0' + date.getSeconds()).substr(-2, 2);
    return hour + ':' + minute;
  },
  //获取今日日期：年-月-日
  gettoDayTime: function () {
    var date = new Date();
    var year = date.getFullYear();
    var month = ('0' + (date.getMonth() + 1)).substr(-2, 2);
    var day = ('0' + date.getDate()).substr(-2, 2);
    var hour = ('0' + date.getHours()).substr(-2, 2);
    var minute = ('0' + date.getMinutes()).substr(-2, 2);
    var sconde = ('0' + date.getSeconds()).substr(-2, 2);
    return year + '-' + month + '-' + day;
  },
};
